import { Link } from "react-router-dom";

export default function Footer() {
  const quickLinks = [
    { to: "/category/xiaoyuan-chengfa", label: "校园惩罚场景" },
    { to: "/category/jiating-chengfa", label: "家庭惩罚场景" },
    { to: "/category/chengzhang-jixuwen", label: "成长记叙文" },
    { to: "/category/xijie-kehua", label: "细节刻画方法" },
    { to: "/category/fanwen-shangxi", label: "范文赏析" },
  ];

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-quill-pen-line text-lg text-background-50"></i>
              </div>
              <span className="text-lg font-semibold text-background-50">打屁股作文</span>
            </div>
            <p className="text-sm text-background-50/60 leading-relaxed">
              专注「打屁股作文」主题，提供经典校园与家庭惩罚场景的作文素材、范文赏析及写作技巧，帮助学生写出真实动人的优秀作文。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              {quickLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <div className="flex flex-col gap-3">
              <div className="flex items-center gap-3 text-sm text-background-50/60">
                <i className="ri-mail-line"></i>
                <span>contact@dapiguzuowen.com</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-background-50/60">
                <i className="ri-phone-line"></i>
                <span>400-888-6666</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-background-50/60">
                <i className="ri-map-pin-line"></i>
                <span>北京市海淀区中关村大街1号</span>
              </div>
              <div className="flex gap-3 mt-2">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信" rel="nofollow">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="QQ" rel="nofollow">
                  <i className="ri-qq-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="w-full px-4 md:px-6 py-4">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 max-w-6xl mx-auto">
            <p className="text-xs text-background-50/40">
              &copy; 2026 打屁股作文 - 写作素材与技巧平台 版权所有
            </p>
            <div className="flex items-center gap-4">
              <Link to="/about" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer">
                关于我们
              </Link>
              <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer" rel="nofollow">
                使用条款
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}